import "./MenuHierarquia.scss";
import UtilServices from "@services/UtilServices";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import { useNavigate } from "react-router-dom";
import MessageServices from "@services/MessageServices";
import { useContext, useEffect, useState } from "react";
import GlobalContext from "@context/GlobalContext";

export default function MenuHierarquia({
  id,
  data,
  nivel,
  menuAberto,
  setMenuAberto,
  setOpenTodoMenu,
  openfilho,
}) {
  const navigate = useNavigate();
  const open = (menuAberto?.[nivel] || null) === id;
  const [active, setActive] = useState("");
  const [state, dispatch] = useContext(GlobalContext);

  function handleVerificaObj(obj) {
    let filhos = [];
    Object.entries(obj).forEach(([key, value]) => {
      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        key !== "icon" &&
        key !== "url" &&
        key !== "label" &&
        key !== "disabled"
      ) {
        filhos.push({ ...value, id: key });
      }
    });
    return filhos;
  }

  const handleClick = () => {
    if (data?.disabled === 1) {
      MessageServices.ShowWarning("Você não tem acesso a esse menu!");
      return;
    }

    if (data?.url) {
      navigate(data?.url);
      setActive(data?.id);
      dispatch({
        type: "SET_MENUATIVO",
        payload: data?.id,
      });
      setOpenTodoMenu(false);
      dispatch({
        type: "SET_OPENMENU",
        payload: false,
      });
      return;
    }
    if (!hasChildren) return;

    setMenuAberto((prev) => ({
      ...prev,
      [nivel]: prev[nivel] === id ? null : id,
    }));
  };

  const filhos = handleVerificaObj(data);
  const hasChildren = filhos.length > 0;

  useEffect(() => {
    setActive(state.ativomenu);
  }, [state.ativomenu]);

  return (
    <li className={`menu-itens ${data?.disabled === 1 ? "disabled" : ""}`}>
      <div
        className={`itens ${open ? "open" : ""} ${
          openfilho && open ? "open-filho" : ""
        } ${active === data?.id ? "active" : ""}`}
        onClick={() => {
          handleClick();
        }}
        data-tooltip-id="tooltip-002"
        data-tooltip-html={data?.title}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <span className="itens-hover" style={{ display: "none" }}></span>
          <span>{UtilServices.stringToJsx(data.icon)}</span>
          <p className="label-icon-aberto">{data.label}</p>
        </div>
        {/* seta */}
        {hasChildren && (
          <ButtonIcon Arrow className="arrow-aberto" openSetArrow={open} />
        )}
      </div>

      {hasChildren && open && (
        <ul className="menuhierarquia-filho">
          {filhos.map((item, index) => (
            <MenuHierarquia
              key={index}
              id={item.id}
              data={item}
              nivel={nivel + 1}
              menuAberto={menuAberto}
              setMenuAberto={setMenuAberto}
              setOpenTodoMenu={setOpenTodoMenu}
              openfilho={true}
            />
          ))}
        </ul>
      )}
    </li>
  );
}
